export default class extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', () => {
      prompt(this.dataset.message, this.dataset.value)
    })
  }
}
